// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e8d669d9","732":"1f36f509","977":"67cdbd4f"}[chunkId] + ".chunk.js";
};